import { useStateMachine } from "components/context/stateMachine/StateMachineContext"
import { Steps } from "components/csd-enrollment/workflow/steps"
import React from "react"
import { Body, Container, FlexContainer, H2 } from "@carrotfertility/carotene"
import L10n from "../../../../lib/carrot-l10n"
import { Spacer } from "../../../views/atoms/Atoms"
import { IlloUnderwaterPlants } from "../../../views/atoms/Illustrations"
import { BenefitEnrollmentModalContinueButton } from "../../shared"

export function SkipMemberConnectInsurance(): JSX.Element {
  const { setNextStep } = useStateMachine(Steps.SKIP_MEMBER_CONNECT_INSURANCE, null)
  const l = new L10n({ locale: "en-US" }).getBoundLocalize()

  function onClickContinue(): void {
    setNextStep(Steps.SKIP_MEMBER_CONNECT_INSURANCE, "")
  }

  return (
    <div>
      <Spacer height={3} />
      <FlexContainer justifyContent="center" padding="none" stack="large">
        <IlloUnderwaterPlants />
      </FlexContainer>
      <H2 stack="tiny" variant="primary">{l`You've skipped connecting to your insurance provider`}</H2>
      <Container padding="none" stack="huge">
        <Body color="black-80">{l`We’ll take it from here and will let you know if we have any more questions about your insurance.`}</Body>
      </Container>
      <BenefitEnrollmentModalContinueButton onClick={onClickContinue} />
    </div>
  )
}
